module.exports = __webpack_public_path__ + "img/contents_title_sub96.0ec31da7.png";